import { ChevronRight, Diamond, Play } from 'lucide-react';
import type { Series } from '../types';

interface ProgressInfo {
  episodeNumber: number;
  progress: number;
}

interface SeriesRowProps {
  title: string;
  icon?: React.ReactNode;
  series: Series[];
  progressBySeriesId?: Record<string, ProgressInfo>;
  onOpenSeries: (series: Series) => void;
  onPlaySeries: (series: Series) => void;
}

export function SeriesRow({ title, icon, series, progressBySeriesId = {}, onOpenSeries, onPlaySeries }: SeriesRowProps) {
  if (series.length === 0) return null;

  return (
    <section className="content-section">
      <div className="section-heading">
        <h2>{icon}{title}</h2>
        <button className="view-all">View all <ChevronRight size={16} /></button>
      </div>
      <div className="card-row">
        {series.map((item) => {
          const progress = progressBySeriesId[item.id];
          return (
            <article className="series-card" key={item.id}>
              <div className="series-image-button">
                <button className="series-open-image" onClick={() => onOpenSeries(item)} aria-label={`Open ${item.title}`}>
                  <img src={item.cardImage} alt="" loading="lazy" />
                  <span className="card-image-gradient" />
                  {item.featured && <span className="new-badge">New</span>}
                </button>
                <button
                  className="card-play"
                  onClick={() => onPlaySeries(item)}
                  aria-label={`Play ${item.title}`}
                >
                  <Play size={17} fill="currentColor" />
                </button>
              </div>
              <button className="card-copy" onClick={() => onOpenSeries(item)}>
                <strong>{item.title}</strong>
                <span>{item.genres.slice(0, 2).join(' • ')} · {item.episodes.length} episodes</span>
                {!progress && (
                  <span className="card-price"><Diamond size={13} /> {item.diamondCost} after episode 4</span>
                )}
              </button>
              {progress && (
                <div className="progress-block">
                  <div className="progress-track"><span style={{ width: `${Math.max(3, progress.progress * 100)}%` }} /></div>
                  <span>S1 E{String(progress.episodeNumber).padStart(2, '0')} · {Math.round(progress.progress * 100)}%</span>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}
